<template>
  <div class="body">
    <div class="header_inner">
      <header>
        <div class="cover">
          <div class="mainMenu">
            <h1 class="top_logo" @click="goHome()"><img src="../../../../assets/images/introMain/logo_w.png" alt=""></h1>
            <h2 class="close_btn" style="color:white;" @click="goHome()">X</h2>
          </div>
          <div class="company">
            <p class="mainTitle">
              우리는 <b class="highlight">인공지능 입시 코디네이터</b> 입니다.
            </p>
            <p class="subTitle">"언제 어디서나 누구든지 부담없이 사용할 수 있도록 <br>
              늘 고민하고 구상합니다."
            </p>
          </div>
        </div>
      </header>
    </div>

    <div class="container">
      <div class="logo">
        <img src="../../../../assets/images/introMain/logo.png" alt="">
        <h1 class="title">PULDA 사용을 위한 가이드</h1>
      </div>
      <div class="wrap">
        <ul class="today" @click="goToday()">
          <li>
            <img src="../../../../assets/images/introMain/today.png" alt="">
          </li>
          <li>
            <h2>오늘 문제</h2>
            <p>랜덤 문제 3개를 풀고 포인트를 벌자!</p>
          </li>
        </ul>
        <ul class="plan" @click="goTest()">
          <li>
            <img src="../../../../assets/images/introMain/trophy.png" alt="">
          </li>
          <li>
            <h2>기출 문제</h2>
            <p>실제 시험처럼 공부하고 싶다면?</p>
          </li>
        </ul>
        <ul class="plan" @click="goPlan()">
          <li>
            <img src="../../../../assets/images/introMain/plan.png" alt="">
          </li>
          <li>
            <h2>플래너</h2>
            <p>스스로 척척 공부 계획 세워보기</p>
          </li>
        </ul>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  methods : {
    goHome() {
      this.$router.push('/pages/intro-pulda-mobile')
    },
    goToday() {
      this.$router.push('/pages/intro-today')
    },
    goTest(){
      this.$router.push('/pages/intro-test')
    },
    goPlan(){
      this.$router.push('/pages/intro-plan')
    }
  }
}
</script>

<style lang="css" scoped>
  *{
    margin: 0;
    padding: 0;
    list-style: none;
    box-sizing: border-box;
  }
  .header_inner {
    background-color: black;
    height: 240px;
  }
  header {
    height: 100%;
    background: url('../../../../assets/images/introPulda/homepage_design01.png') no-repeat right;
    background-size: cover !important;
  }
  .cover {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
  }
  .mainMenu{
    width: 100%;
    height: 60px;
    padding: 13px 10px;
    position: fixed;
    display: flex;
    justify-content: space-between;
    color: #fff;
    z-index: 1000;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }
  .mainMenu h1 img {
    width: 60px;
  }
  .mainSec{
    position: relative;
    width: 100%;
    height: 100%;
    border: 1px solid red;
  }
  .company {
    width: 100%;
    height: 100%;
    padding: 130px 0px 0 20px;
    color: white;
  }
  .mainSecInner{
    position: absolute;
    top: 55%;
    left: 2rem;
    z-index: 11;
  }
  .mainTitle{
    font-size: 1.3em;
    margin-bottom: 2rem;
    white-space: nowrap;
  }
  .subTitle{
    font-size: 0.9em;
  }
  .mainTitle .highlight{
    position: relative;
    font-weight: bolder;
    z-index: 1
  }
  .mainTitle .highlight::before{
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 60%;
    background-color: rgba(255, 235, 0, 0.8);
    z-index: -1
  }
  .body {
    width: 100vw;
    height: 100vh;
    font-size: 13px;
    font-family: 'NanumSquare','Noto Sans KR','Malgun Gothic', sans-serif;
  }
  .container {
    width: 90%;
    max-width: 500px;
    margin: 0 auto;
  }
  .title {
    margin-top: 5px;
    font-size: 1em;
    font-weight: bold;
    color: black;
  }
  .logo {
    width: 100%;
    height: 100px;
    margin: 30px auto;
    text-align: center;
    border-radius: 10px;
    box-shadow : 0 2px 4px 0 rgb(0 0 0 / 15%), 0 3px 10px 0 rgb(0 0 0 / 14%);
  }
  .logo img {
    width: 150px;
    margin-top: 20px;
  }
  .container ul {
    display: flex;
    width: 100%;
    height: 100px;
    margin: 15px 0;
    border-radius: 10px;
  }
  .container ul li:first-child {
    width: 30%;
    border-radius: 10px;
    text-align: center;
    box-shadow : 0 2px 4px 0 rgb(0 0 0 / 15%), 0 3px 10px 0 rgb(0 0 0 / 14%);
  }
  .container ul li:last-child {
    width: 70%;
    border-bottom: 1px solid #ddd;
    padding: 30px 15px;
  }
  .container ul li h2 {
    font-size: 1.5em;
    font-weight: bold;
  }
  .container ul li p {
    font-size: 0.8em;
  }
  .container ul:hover {
    background: #ddd;
    color: white;
  }
  .container ul li img {
    width: 100%;
    max-width: 100px;
    border-radius: 10px;
  }

  @media screen and (max-height:450px) {
    .con_wrap {
      display: flex;
      padding: 30px 0 10px 0;
    }
    .container {
      max-width: 700px;
    }
    .title {
      font-size: 0.8em;
    }
    .back {
      height: 45px;
      padding: 5px 0;
    }
    .logo {
      height: 80px;
    }
    .logo img {
      margin-top: 10px;
    }
    .wrap {
      display: flex;
    }
    .container ul {
      height: 70px;
    }
    .container ul li:first-child {
      height: 70px
    }
    .container ul li:last-child {
      padding: 15px 10px;
    }
    .container ul li h2 {
      font-size: 1.2em;
      font-weight: bold;
    }
    .container ul li p {
      font-size: 0.7em;
    }
  }
  @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR&display=swap');
</style>
